import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Paper,
  FormControl,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useRef, useState } from "react";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ConfirmationDialog from "../../../common/ConfirmationDialog";
import { PlayerProfileService } from "../../../services/playerProfile.Service";
import { useContext } from "react";
import AppDataContext from "../../../common/appContext";
import AppConstatnts from "../../../common/AppConstants";
import Loader from "../../../sharedComponents/loader/loader";
import DataGridCustom from "../../../sharedComponents/dataGrid/DataGridCustom";
import TitleTooltip from "../../../sharedComponents/Tooltip/TitleTooltip";
import { getInputBox } from "../../../sharedComponents/formFields/LabelInFormFields";

const ClubProgramsViewUpdate = ({
  eventId,
  playerID,
  gridPropsData,
  styles,
  viewProfile,
  setAlert,
  setAlertType,
  setAlertMessage,
  //   user,
}) => {
  const useStyles = makeStyles((theme) => styles);
  const classes = useStyles();
  const { user } = useContext(AppDataContext);
  const formData = {
    eventId: eventId,
    circuit: "",
    id: 0,
    location: "",
    mode: "",
    playerID: playerID,
    programs: "",
    programsContact: "",
    programsEmail: "",
    programsPhone: "",
    userBy: user?.loginID,
  };
  const defaultErrors = { programsEmail: false };
  const defaultErrorMsg = { programsEmail: "" };
  const [aauGridData, setAauGridData] = useState([]);
  const [aauFormData, setAauFormData] = useState({});
  const [openConfirmationBox, setOpenConfirmationBox] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [deletedRowID, setDeletedRowId] = useState(-1);
  const [error, setError] = useState(defaultErrors);
  const [errorMessage, setErrorMessage] = useState(defaultErrorMsg);
  const [columnFlex, setColumnFlex] = useState(
    window.innerWidth >= 1570 ? 1 : "none"
  );
  const columns = [
    { field: "id", hide: true, flex: 1 },
    // {
    //   field: "location",
    //   headerName: "AAU/Club Location",
    //   width: 180,
    //   flex: columnFlex,
    // },
    {
      field: "circuit",
      headerName: "AAU Circuit",
      width: 150,
      flex: columnFlex,
    },
    {
      field: "programs",
      headerName: "AAU/Club Programs",
      width: 180,
      flex: columnFlex,
    },
    {
      field: "programsContact",
      headerName: "AAU/Club Programs Contact",
      width: 230,
      flex: columnFlex,
    },
    {
      field: "programsPhone",
      headerName: "AAU/Club Programs Contact Phone",
      width: 280,
      flex: columnFlex,
    },
    {
      field: "programsEmail",
      headerName: "AAU/Club Programs Contact Email",
      width: 280,
      flex: columnFlex,
    },
  ];
  useEffect(() => {
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  useEffect(() => {
    setAauFormData(formData);
    setAauGridData(gridPropsData);
  }, [gridPropsData]);

  //---UTILs---

  const onResize = () => {
    setColumnFlex(window.innerWidth >= 1570 ? 1 : "none");
  };

  const toggleAlert = (open, type, message) => {
    setAlert(open);
    setAlertType(type);
    setAlertMessage(message);
  };

  const toggleError = (key, val, message) => {
    setError({ ...error, [key]: val });
    setErrorMessage({ ...errorMessage, [key]: message });
  };
  const resetError = () => {
    setError(defaultErrors);
    setErrorMessage(defaultErrorMsg);
  };

  const validateErrors = () => {
    let valid = true;
    Object.keys(error).forEach((key) => {
      valid = valid && !error[key];
    });
    if (!valid) {
      toggleAlert(true, "warning", "Please correct the invalid fields.");
    }
    return valid;
  };

  const checkIfSaveBtnDisabled = () => {
    return aauFormData.circuit ||
      aauFormData.programs ||
      aauFormData.programsContact ||
      aauFormData.programsEmail ||
      aauFormData.programsPhone
      ? false
      : true;
  };

  //---HANDLERS---

  //single handler to open and close delete confirmation dialog box
  const handleOpenCloseConfirmationBox = (val) => {
    if (val === false) {
      setDeletedRowId(-1);
    }
    setOpenConfirmationBox(val);
  };

  //1. find the aau club details to edit from grid data
  //2. set the input boxes with aau club details to edit
  //3. set userBy to current user -- for DB record
  const handleRowEditClick = (id) => {
    resetError();
    setIsUpdate(true);
    let result = aauGridData.find((a, i) => {
      return a.id === id;
    });
    setAauFormData({ ...result, userBy: user?.loginID });
  };

  const handleRowDeleteClick = (id) => {
    setDeletedRowId(id);
    handleOpenCloseConfirmationBox(true);
  };

  //reset the input boxes with initially declared empty formData
  const handleCancelUpdate = () => {
    resetError();
    setIsUpdate(false);
    setAauFormData(formData);
  };

  //common input field change handler
  const handleInputChange = (e, key) => {
    let value = e.target.value;
    let defaultVal = "";
    switch (key) {
      case "programsEmail":
        if (
          value &&
          !value.toLowerCase().match(AppConstatnts.VALIDATIONS.EMAIL_REGEX)
        ) {
          toggleError(key, true, "Invalid email");
        } else toggleError(key, false, "");
        break;
    }
    setAauFormData({ ...aauFormData, [key]: value || defaultVal });
  };

  //1. validate then call api to save
  //2. after save reset necessary values
  const handleSaveClick = () => {
    if (!checkIfSaveBtnDisabled() && validateErrors()) {
      const result = handleSubmit(aauFormData);
      if (result) {
        handleCancelUpdate();
        toggleAlert(true, "success", "Data uploaded successfully.");
      }
    }
  };

  //1. find the record to delete from grid data
  //2. set the mode to "delete" --- for DB
  //3. after delete reset necessary values
  const handleDeleteClick = () => {
    let record = aauGridData.find((a, i) => {
      return a.id === deletedRowID;
    });
    if (record) {
      const updatedForm = {
        ...record,
        mode: "delete",
        userBy: user.loginID,
      };
      const result = handleSubmit(updatedForm);
      if (result) {
        handleCancelUpdate();
        handleOpenCloseConfirmationBox(false);
        toggleAlert(
          true,
          "success",
          "AAU/Club programs record deleted Successfully."
        );
      }
    }
  };

  //---APIs---

  //to create, update or delete a record -- common api
  const handleSubmit = async (formData) => {
    console.log("submit form data : ", formData);
    setIsLoading(true);
    try {
      const result = await PlayerProfileService.insertUpdateClubProgramDetails(
        formData
      );
      if (result) {
        getUpdatedAauGridData();
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
      toggleAlert(true, "error", "Something went wrong.");
    } finally {
      setIsLoading(false);
    }
  };

  //get updated records after creating, updating or deleting record, for view
  const getUpdatedAauGridData = async () => {
    try {
      const result = await PlayerProfileService.getPlayersProfileData(
        playerID,
        eventId,
        user?.loginID
      );
      setAauGridData(result.data.aauClub);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      {isLoading && <Loader isLoading={isLoading}></Loader>}
      <Paper square elevation={5} className={classes.paperStyle}>
        <Grid container>
          <Grid
            item
            lg={10}
            md={10}
            sm={10}
            xs={10}
            className={classes.sectionTitlePadding}
          >
            <Typography
              noWrap
              variant="subtitle1"
              fontWeight="medium"
              color="secondary"
            >
              AAU/Club Programs
            </Typography>
          </Grid>
          {!viewProfile ? (
            <Grid
              item
              lg={2}
              md={2}
              sm={2}
              xs={2}
              className={classes.inputSectionPadding}
            >
              <Box>
                {isUpdate ? (
                  <Button
                    className={classes.cancelButton}
                    size={classes.submitButtonSize}
                    variant={styles.cancelButton.variant}
                    title={styles.cancelButton.title}
                    onClick={handleCancelUpdate}
                  >
                    <TitleTooltip title="Cancel">
                      <CancelOutlinedIcon
                        sx={{ color: styles.cancelButton.cancelIconColor }}
                      />
                    </TitleTooltip>
                  </Button>
                ) : (
                  ""
                )}
                <Button
                  className={classes.saveButton}
                  size={classes.submitButtonSize}
                  variant={styles.saveButton.variant}
                  title={styles.saveButton.title}
                  disabled={checkIfSaveBtnDisabled()}
                  onClick={handleSaveClick}
                >
                  <TitleTooltip title="Save AAU/club details">
                    <SaveOutlinedIcon />
                  </TitleTooltip>
                </Button>
              </Box>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
        {!viewProfile ? (
          <Grid
            key={0}
            container
            pl={2}
            pr={2}
            spacing={2}
            justifyContent={"start"}
          >
            {/* <Grid item lg={1.6} md={6} sm={12} xs={12}>
              {getInputBox("AAU/Club Location", aauFormData.location, (e) => {
                handleInputChange(e, "location");
              })}
            </Grid> */}
            <Grid item lg={1.4} md={6} sm={12} xs={12}>
              {getInputBox("AAU Circuit", aauFormData.circuit, (e) => {
                handleInputChange(e, "circuit");
              })}
            </Grid>
            <Grid item lg={1.9} md={6} sm={12} xs={12}>
              {getInputBox("AAU/Club Programs", aauFormData.programs, (e) =>
                handleInputChange(e, "programs")
              )}
            </Grid>
            <Grid item lg={2.1} md={6} sm={12} xs={12}>
              {getInputBox(
                "AAU/Club Programs Contact",
                aauFormData.programsContact,
                (e) => handleInputChange(e, "programsContact")
              )}
            </Grid>
            <Grid item lg={2.5} md={6} sm={12} xs={12}>
              {getInputBox(
                "AAU/Club Programs Contact Phone",
                aauFormData.programsPhone,
                (e) => handleInputChange(e, "programsPhone")
              )}
            </Grid>
            <Grid item lg={2.5} md={6} sm={12} xs={12}>
              {getInputBox(
                "AAU/Club Programs Contact Email",
                aauFormData.programsEmail,
                (e) => handleInputChange(e, "programsEmail"),
                false,
                "text",
                error.programsEmail
                // errorMessage.programsEmail
              )}
            </Grid>
          </Grid>
        ) : (
          ""
        )}
        <Grid item xs={12} className={classes.dataGridPadding}>
          <DataGridCustom
            classes={classes}
            styles={styles}
            columns={columns}
            rows={aauGridData}
            viewProfile={viewProfile}
            handleRowEditClick={handleRowEditClick}
            handleRowDeleteClick={handleRowDeleteClick}
          />
          <ConfirmationDialog
            keepMounted
            open={openConfirmationBox}
            onClose={() => {
              handleOpenCloseConfirmationBox(false);
            }}
            onSubmit={handleDeleteClick}
          />
        </Grid>
      </Paper>
    </>
  );
};
export default React.memo(ClubProgramsViewUpdate);
